import {computed, onMounted, ref, watch} from "vue";
import {useQuery, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";

const useUser = () => {
  const query = useQuery({
    queryKey: ['current-user'],
    queryFn: () => axios.get('/ajax/v2/user'),
  });

  const user = computed(() => query.data.value?.data?.data);

  const hasFeature = (feature) => user.value?.features[feature] === true;

  const hasAccessToOptimiser = computed(() => user.value?.optimiser_access);
  const hasSeoScoreFeature = computed(() => user.value?.can_view_seo_score === true);
  // only used on sitemap page and NOT ai-onboarding
  const hasSitemapAiAutoAssignFeature = computed(() => hasFeature('SitemapAiAutoAssignFeature'));
  const isAdmin = computed(() => ['ADMIN', 'DEVELOPER'].includes(user.value?.user_type));
  const isReseller = computed(() => user.value?.is_reseller);
  const isActiveWebsiteAgency = computed(() => user.value?.is_active_website_agency);
  const isDeveloper = computed(() => user.value?.user_type === 'DEVELOPER');
  const isOnTrial = computed(() => user.value?.on_trial);
  const isSubscribedToKit = computed(() => user.value?.subscribed_to_kit === true);
  const isOrganisationAdmin = computed(() => user.value?.is_organisation_admin);
  const canManageEmailSettings = computed(() => user.value?.can_manage_email_settings);

  return {
    ...query,
    user,
    hasFeature,
    hasSeoScoreFeature,
    hasSitemapAiAutoAssignFeature,
    hasAccessToOptimiser,
    isAdmin,
    isDeveloper,
    isReseller,
    isActiveWebsiteAgency,
    isOnTrial,
    isSubscribedToKit,
    isOrganisationAdmin,
    canManageEmailSettings,
  };
};

export default useUser;
